/**
 * User-facing copy for Quick Call / dialer flows.
 */
export const DIALER_CALL_COPY = {
  title: 'Quick Call',
  description: 'Choose the agent and business line for this outbound call.',
  fields: {
    customerNumber: {
      label: 'Customer number',
      helper: 'The contact you are calling from this conversation.',
    },
    agent: {
      label: 'Agent',
      placeholder: 'Select agent',
      helper: 'Agent whose phone will connect to the call.',
    },
    callFrom: {
      label: 'Call from number',
      placeholder: 'Select business number',
      helper: 'Shown as caller ID on the customer\'s phone.',
    },
  },
  actions: {
    cancel: 'Cancel',
    submit: 'Start call',
    submitting: 'Starting call…',
  },
  errors: {
    destination_number: 'Customer number is required',
    agent_number: 'Select an agent',
    caller_id: 'Select a call-from number',
  },
  notifications: {
    loadFailed: 'Failed to load call options',
    success: 'Call initiated',
    failed: 'Failed to initiate call',
  },
};
